import { use, useMemo } from 'react';
import { createCallSettingsPromise } from '../api/callSettingsPromise';
import { guardedClient } from '../../auth/api/clients';
import type { CallSetting, Honbu } from '../types';

/**
 * 指定した本部の即架電設定一覧を返す。
 * 取得完了まで suspend するため Suspense 境界内で呼ぶこと。取得失敗は ErrorBoundary に伝播する。
 */
export const useCallSettings = (honbu: Honbu): CallSetting[] => {
  const settings = use(createCallSettingsPromise(guardedClient));
  // use() の結果は単一フライトキャッシュにより同一参照で安定するため、依存の変化は実質 honbu のみ。
  // 返す配列の参照を安定させ、メモ化されたコンポーネントや依存配列に渡されたときの不要な再計算を避ける。
  return useMemo(() => settings.filter(setting => setting.honbu === honbu), [settings, honbu]);
};
